import type { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import { HeaderMinimal } from '@xing-com/crate-layout-header-minimal';
import { Section } from '@xing-com/layout-primitives';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { BottomBar } from '@xing-com/platform-layout-bottom-bar';
import { Footer, LegalFooter } from '@xing-com/platform-layout-footer';
import { scale280, spaceL, spaceXXL } from '@xing-com/tokens';
import { GridContainer } from '@xing-com/xing-grid';

type StyledFooterProps = {
  $addMobileTopSpacing: boolean;
};

const StyledFooter = styled.footer<StyledFooterProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: ${spaceXXL} ${spaceL};

  @media ${mediaSmallOrTiny} {
    padding-top: ${({ $addMobileTopSpacing }) =>
      $addMobileTopSpacing ? scale280 : spaceXXL};
  }
`;

type UpsellFrameProps = {
  addMobileTopSpacing?: boolean;
  fullFooter?: boolean;
  hideBottomBar?: boolean;
};

export const UpsellFrame: FC<PropsWithChildren<UpsellFrameProps>> = ({
  addMobileTopSpacing = false,
  children,
  fullFooter,
  hideBottomBar = false,
}) => {
  return (
    <>
      <HeaderMinimal showOnSmallerScreens />

      <main id="content">
        <Section noBlockPadding>
          <GridContainer type="wide">{children}</GridContainer>
        </Section>
      </main>

      {fullFooter ? (
        <Footer homeLink="/" />
      ) : (
        <StyledFooter $addMobileTopSpacing={addMobileTopSpacing}>
          <LegalFooter />
        </StyledFooter>
      )}
      {hideBottomBar ? null : <BottomBar />}
    </>
  );
};
